// interface Alert {
//   title?: string;
//   body?: string;
//   showCancelButton?: boolean;
//   cancelButtonText?: string;
//   confirmButtonText?: string;
// }

import store from "@/store";
import swal from "sweetalert2";
import { RouterBeforeTaskItem } from "@/router/router-before-task";
import core from "@/core/index";

class CoreAlert {
  tag = "swal";

  constructor() {}

  show(params) {
    //console.log("params : ", params);
    core.loader.hide();

    return new Promise((resolve, reject) => {
      if (params.showCancelButton == null) params.showCancelButton = false;
      if (params.title == null) params.title = "알림";
      if (params.icon == null) params.icon = "info";
      if (params.confirmButtonText == null) params.confirmButtonText = "확인";
      if (params.cancelButtonText == null) params.cancelButtonText = "취소";
      if (params.customClass == null) params.customClass = "";

      let isShow = true;
      swal
        .fire({
          icon: params.icon,
          title: params.title,
          html: params.body,
          showCancelButton: params.showCancelButton,
          cancelButtonText: params.cancelButtonText,
          confirmButtonText: params.confirmButtonText,
          allowOutsideClick: false,
          reverseButtons: true,
          customClass: params.customClass,
        })
        .then((result) => {
          if (result.isConfirmed) {
            resolve("confirm");
            isShow = false;
          } else {
            resolve("cancel");
            isShow = false;
          }
        });

      const routerBeforeTask = store.state.routerBeforeTask;
      const routerBeforeTaskItem = new RouterBeforeTaskItem(this.tag, () => {
        if (isShow) {
          swal.close();
        }
        return !isShow;
      });
      routerBeforeTask.pushModal(routerBeforeTaskItem);
    });
  }
}

export default new CoreAlert();
